import React, { useState } from "react";
import DJLeaderboard from "./DJLeaderboard";
import TopDJsBoard from "./TopDJsBoard";
import TopFansBoard from "./TopFansBoard";
import "../pages/LeaderboardPage.css";
import { t } from "../i18n";

// The leaderboard's three views behind a pill toggle — the original Songs &
// Artists boards, the platform-wide Top Talent board and the Top Fans
// (spenders) board. Songs & Artists stays the default. Shared by the
// /leaderboard page (links, the fan side) and the Leaderboard sheet the
// Profile tab opens (1.5.2 b48: the same slide-up as Stats and Refer
// & Earn, instead of a jump to another page). Each board keeps its data for
// the session, so switching views never flashes a skeleton.
type View = "songs" | "djs" | "fans";

// One-line "what am I looking at" per view, shown right under the toggle.
const VIEW_EXPLAINERS: Record<View, string> = {
  songs: t("leaderboardPage.songsExplainer"),
  djs: t("leaderboardPage.requestsFromUniqueFans"),
  fans: t("leaderboardPage.biggestSpendersAcrossAll"),
};

const LeaderboardViews: React.FC = () => {
  const [view, setView] = useState<View>("songs");
  return (
    <>
      <div className="lb-mode-toggle" role="tablist" aria-label={t("leaderboardPage.leaderboardView")}>
        <button
          type="button"
          role="tab"
          aria-selected={view === "songs"}
          className={`lb-mode-btn${view === "songs" ? " lb-mode-btn--active" : ""}`}
          onClick={() => setView("songs")}
        >
          {t("leaderboardPage.songsArtists")}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={view === "djs"}
          className={`lb-mode-btn${view === "djs" ? " lb-mode-btn--active" : ""}`}
          onClick={() => setView("djs")}
        >
          {t("leaderboardPage.topTalent")}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={view === "fans"}
          className={`lb-mode-btn${view === "fans" ? " lb-mode-btn--active" : ""}`}
          onClick={() => setView("fans")}
        >
          {t("leaderboardPage.topFans")}
        </button>
      </div>
      <div className="lb-explainer">{VIEW_EXPLAINERS[view]}</div>

      {view === "songs" ? (
        <DJLeaderboard showHeader={false} />
      ) : view === "djs" ? (
        <TopDJsBoard />
      ) : (
        <>
          {/* Link Unique Visitors moved to the Requests tab's Fans chip
              (founder, build 35: "wrong place — not in leaderboard"). */}
          <TopFansBoard />
        </>
      )}
    </>
  );
};

export default LeaderboardViews;
